import { z, ZodLazy } from 'zod';
import axios from "axios";
import AuthService from "./../components/auth.service";
import APIS from "./../apis";
import settings from "./../settings.json";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, IconButton, SendButton } from "../components/Button";
import { SecondTitle, Title } from "../components/Heading";
import { Main } from "../components/structure/Main";
import { cartClose, cartOpen, selectCartOpen } from "../features/cart/cartSlice";
import { useAppDispatch, useAppSelector } from "../hooks";
import { faArrowLeft, faShoppingCart } from "@fortawesome/free-solid-svg-icons";
import { Dispatch, SetStateAction, useEffect, useState } from "react";
import { Box, Collapse, Paper, Table, TableBody, TableCell, TableContainer, TableRow } from "@material-ui/core";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@material-ui/icons/KeyboardArrowUp";
import { Checkbox } from "../components/Table";
import OutlinedNumberInput from "../components/OutlinedNumberInput";
import { CircularProgress } from "../components/CircularProgress";
import { SearchField } from "../components/Form";
import { Drawer, DrawerFooter } from "../components/Drawer";
import { useHistory } from "react-router-dom";
import CartInfo from "../features/items/cart/CartInfo";
import DeleteIcon from "@material-ui/icons/Delete";
import CartList from "../features/items/cart/CartList";
import { Content } from "../components/Content";
import SendIcon from "@material-ui/icons/Send";

interface CartItemT {
    name: string;
    quantity: number;
    unitPrice: number;
}

const GroupSchema = z.object({
    id: z.number(),
    description: z.string(),
    item_ids: z.array(z.number())
})
type GroupT = z.infer<typeof GroupSchema>;

const ItemSchema = z.object({
    id: z.number(),
    state: z.number(),
    name: z.string(),
    description: z.string(),
    item_class: z.number(),
    svg: z.optional(z.string()),
    prices: z.record(z.number()),
    cart_quantity: z.number()
});
type ItemT = z.infer<typeof ItemSchema>;

interface SearchedGroupT {
    groupId: number;
    groupName: string;
    items: ItemT[];
}

const Item = (props: {
    item: ItemT,
    setItem: (item: ItemT) => void
}) => {
    const { item, setItem } = props;
    const cartOpen = useAppSelector(selectCartOpen);

    const requestNumberChange = (newNumber: number) => {
        if (newNumber === item.cart_quantity) return;

        const getToken = AuthService.authHeader();
        getToken.then((token) => {
            axios
                .patch(settings.webservice_url + APIS.items + item.id + "/",
                    { cart_quantity: newNumber },
                    { headers: token })
                .then((response) => {
                    console.log(response);
                    if (response.data) {
                        if ("cart_quantity" in response.data) {
                            setItem({ ...item, cart_quantity: response.data["cart_quantity"] });
                        }
                    }
                })
                .catch((error) => {
                    console.error(error)
                });
        });
    }

    let editTimer: NodeJS.Timeout | null;
    const handleNumberChange = (newNumber: number) => {
        if (editTimer) clearTimeout(editTimer);
        editTimer = setTimeout(() => {
            requestNumberChange(newNumber);
        }, 500);
    }


    return <TableRow>
        <TableCell>{item.name}</TableCell>
        <TableCell>{item.description}</TableCell>
        <TableCell>
            <div style={{
                width: 220,
                height: 220
            }}>
                {item.svg ?
                    <div
                        dangerouslySetInnerHTML={{ __html: item.svg }}
                        style={{ width: "100%", height: "100%", filter: "invert()" }}
                    />
                    : <CircularProgress />}
            </div>
        </TableCell>
        <TableCell>
            {cartOpen ? (
                <Checkbox
                    checked={item.cart_quantity > 0 ? true : false}
                    onChange={(e, checked) => { checked ? requestNumberChange(1) : requestNumberChange(0) }}
                />
            ) : null}
        </TableCell>
        <TableCell>
            {item.cart_quantity > 0 && cartOpen ? (
                <OutlinedNumberInput
                    initValue={item.cart_quantity}
                    minValue={1}
                    onChange={handleNumberChange}
                />
            ) : null}
        </TableCell>
    </TableRow>
}

const Group = (props: {
    isSearching: boolean,
    searchedGroup: SearchedGroupT,
    setItems: Dispatch<SetStateAction<ItemT[]>>
}) => {
    const { searchedGroup, isSearching, setItems } = props;
    const [open, setOpen] = useState(false);
    const cartOpen = useAppSelector(selectCartOpen);

    if (searchedGroup.items.length === 0) {
        return null;
    } else return (
        <TableBody>
            <TableRow>
                <TableCell style={{ width: "20px" }}>
                    <IconButton
                        aria-label="expand row"
                        size="small"
                        onClick={() => setOpen(!open)}
                    >
                        {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                    </IconButton>
                </TableCell>
                <TableCell colSpan={2}>{searchedGroup.groupName}</TableCell>
                <TableCell colSpan={2}>{searchedGroup.items.length} {searchedGroup.items.length === 1 ? "articolo" : "articoli"}</TableCell>
            </TableRow>
            <TableRow>
                <TableCell style={{ padding: 0 }} colSpan={5}>
                    <Collapse
                        in={open || isSearching}
                        timeout="auto"
                        unmountOnExit
                    >
                        <Box style={{ padding: "10px" }}>
                            <TableContainer component={Paper}>
                                <Table aria-label="collapsible table">
                                    <TableBody>
                                        <TableRow>
                                            <TableCell>Codice</TableCell>
                                            <TableCell>Nome</TableCell>
                                            <TableCell>Immagine</TableCell>
                                            <TableCell>{cartOpen ? "Ordina" : null}</TableCell>
                                            <TableCell style={{ width: "15rem" }} />
                                        </TableRow>
                                        {searchedGroup.items.map((item, index) =>
                                            <Item
                                                key={item.id}
                                                item={item}
                                                setItem={
                                                    (item: ItemT) => {
                                                        setItems((p) => p.map((c, i) => {
                                                            if (c.id === item.id) {
                                                                return item;
                                                            } else {
                                                                return c;
                                                            }
                                                        }))
                                                    }
                                                }
                                            />
                                        )}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Box>
                    </Collapse>
                </TableCell>
            </TableRow>
        </TableBody>
    );
}

const CartDrawer = (props: {
    items: CartItemT[];
    clearCart: () => void;
}) => {
    const { items, clearCart } = props;
    const dispatch = useAppDispatch();
    const [description, setDescription] = useState<string>("");
    const [deliveryDate, setDeliveryDate] = useState<string>(
        new Date().toJSON().slice(0, 10)
    );
    const [newOrderState, setNewOrderState] = useState<
        "idle" | "loading" | "failed" | "succeeded"
    >("idle");
    const [newOrderError, setNewOrderError] = useState<string>("");

    const open = useAppSelector((state) => state.cart.open);

    const history = useHistory();

    const handleSubmit = () => {
        setNewOrderState("loading");
        AuthService.authHeader().then((token) => {
            const data = {
                name: description !== "" ? description : "Particolari carpenteria",
                delivery_date: deliveryDate,
            };

            axios
                .post(settings.webservice_url + APIS.makeOrder, data, {
                    headers: token,
                })
                .then((response) => {
                    setNewOrderState("succeeded");
                    history.push("/orders");
                })
                .catch((error) => {
                    console.error(error);
                    setNewOrderState("failed");
                    setNewOrderError(error.detail);
                });
        });
    };

    const handleCartClear = () => {
        AuthService.authHeader().then((token) => {
            axios
                .delete(settings.webservice_url + APIS.cart, { headers: token })
                .then((response) => {
                    clearCart();
                })
                .catch((error) => {
                    console.log(error);
                });
        });
    };

    const handleDrawerToggle = () => {
        if (open) dispatch(cartClose());
        else dispatch(cartOpen());
    };

    const totalPrice = items.reduce((prevValue, item) => {
        return (prevValue + item.unitPrice * item.quantity)
    }, 0).toFixed(2);

    return (
        <Drawer open={open}>
            <div style={{ display: "grid", gridTemplateColumns: "1fr auto 1fr" }}>
                <IconButton
                    onClick={handleDrawerToggle}
                    style={{ width: "3rem", height: "3rem" }}
                >
                    <FontAwesomeIcon className="nav-icon" icon={faArrowLeft} />
                </IconButton>
                <Title>Ordine</Title>
            </div>

            <CartInfo
                description={description}
                setDescription={setDescription}
                deliveryDate={deliveryDate}
                setDeliveryDate={setDeliveryDate}
            />
            <div style={{ display: "flex", justifyContent: "space-between" }}>
                <SecondTitle style={{ marginTop: 20, marginLeft: 5 }}>
                    Articoli
                </SecondTitle>
                {items.length > 0 ? (
                    <Button onClick={handleCartClear}>
                        <DeleteIcon />
                    </Button>
                ) : null}
            </div>

            <CartList items={items} />
            <DrawerFooter>
                <SecondTitle>
                    <b>Totale:</b> {totalPrice} €
                    <i style={{ fontSize: "0.75rem" }}>(IVA esclusa)</i>
                </SecondTitle>
                {newOrderState == "failed" ? (
                    <Content>⛔️ {newOrderError}</Content>
                ) : (
                    <SendButton
                        variant="extended"
                        onClick={handleSubmit}
                        disabled={items.length === 0}
                    >
                        {newOrderState == "loading" ? (
                            <CircularProgress />
                        ) : (
                            <>
                                <SendIcon /> Ordina
                            </>
                        )}
                    </SendButton>
                )}
            </DrawerFooter>
        </Drawer>
    );
};

const ItemsPage = () => {
    const dispatch = useAppDispatch()
    const open = useAppSelector(selectCartOpen);

    const [groups, setGroups] = useState<GroupT[]>([]);
    const [groupsStatus, setGroupsStatus] = useState<"idle" | "fetching" | "completed" | "error">("idle")

    const [searchingItemName, setSearchingItemName] = useState<String>("");
    const [searchedGroups, setSearchedGroups] = useState<SearchedGroupT[]>([])

    const [items, setItems] = useState<ItemT[]>([]);
    const [itemsStatus, setItemsStatus] = useState<"idle" | "fetching" | "completed" | "error">("idle")

    const [itemImagesStatuses, setItemImagesStatuses] = useState<{
        [groupId: string]: ("idle" | "fetching" |
            "completed" | "error")
    }>({})
    const [fetchingItemImages, setFetchingItemImages] = useState<boolean>(false);

    useEffect(() => {
        if (groupsStatus === "idle") {
            if (!AuthService.getCustomerId()) {
                console.error("customer id not found");
                return;
            }

            const getToken = AuthService.authHeader();
            getToken.then((token) => {
                axios
                    .get(settings.webservice_url + APIS.groups, {
                        headers: token
                    })
                    .then((response) => {
                        if (response.data.results) {
                            const payload = response.data.results;
                            const typeCheck = z.array(GroupSchema).safeParse(payload);
                            if (typeCheck.success) {
                                setGroups(payload);
                                setGroupsStatus("completed");
                            } else {
                                console.error(typeCheck.error);
                            }
                        }
                    })
                    .catch((error) => {
                        setGroupsStatus("error")
                        console.error(error)
                    });
            });
            setGroupsStatus("fetching");
        }
    }, [groupsStatus])

    useEffect(() => {
        if (groupsStatus === "completed" && itemsStatus === "idle") {
            setItemsStatus("fetching")

            const getToken = AuthService.authHeader();

            if (!AuthService.getCustomerId()) {
                console.error("customer id not found");
                return;
            }

            getToken.then((token) => {
                axios
                    .get(settings.webservice_url + APIS.items, {
                        headers: token
                    })
                    .then((response) => {
                        if (response.data) {
                            const payload = response.data;
                            const typeCheck = z.array(ItemSchema).safeParse(payload);
                            if (typeCheck.success) {
                                setItems(payload.sort((a: ItemT, b: ItemT) => { return a.name > b.name ? 1 : -1 }));
                                setItemsStatus("completed")

                                let newImageStatus: any = {};
                                for (const item of payload as ItemT[]) {
                                    newImageStatus[item.id] = "idle"
                                }

                                setItemImagesStatuses(newImageStatus)
                            } else {
                                console.error(typeCheck.error);
                            }
                        }
                    })
                    .catch((error) => {
                        setItemsStatus("error")
                        console.error(error)
                    });
            })
        }
    }, [groupsStatus])

    useEffect(() => {
        if (Object.keys(itemImagesStatuses).length > 0 && !fetchingItemImages) {
            setFetchingItemImages(true);

            const getToken = AuthService.authHeader();

            if (!AuthService.getCustomerId()) {
                console.error("customer id not found");
                return;
            }

            getToken.then((token) => {
                for (const itemId of Object.keys(itemImagesStatuses)) {
                    axios
                        .get(settings.webservice_url + APIS.items + itemId + "/image.svg", {
                            headers: token
                        })
                        .then((response) => {
                            if (response.data) {
                                let payload = response.data;
                                payload = payload.replace(
                                    /<svg([^>]*?)\s+width="[^"]*"/g,
                                    '<svg$1 width="200px"'
                                );
                                payload = payload.replace(
                                    /<svg([^>]*?)\s+height="[^"]*"/g,
                                    '<svg$1 height="200px"'
                                );

                                setItems((p) => {
                                    return p.map((item) => {
                                        if (item.id === parseInt(itemId)) {
                                            return { ...item, svg: payload };
                                        } else {
                                            return item;
                                        }
                                    });
                                })
                            }
                        })
                        .catch((error) => {
                            setItemsStatus("error")
                            console.error(error)
                        });
                }
            })
        }
    }, [itemImagesStatuses])

    useEffect(() => {
        if (itemsStatus === "completed") {
            const newSearchedGroup = groups.map((group) => {
                return {
                    groupId: group.id,
                    groupName: group.description,
                    items: items.filter((item) => {
                        {
                            return group.item_ids.includes(item.id) && (searchingItemName !== ""
                                ? (item.name + item.description).toLocaleLowerCase().includes(searchingItemName.toLocaleLowerCase())
                                : true)
                        }

                    })
                }
            })

            setSearchedGroups(newSearchedGroup);
        }
    }, [itemsStatus, searchingItemName, items])

    const handleDrawerToggle = () => {
        if (open) dispatch(cartClose());
        else dispatch(cartOpen());
    };

    const selectCartItems = (): CartItemT[] => items.filter((item) => item.cart_quantity > 0).map((item) => {
        const sortedPrices = Object.keys(item.prices).map((strQuantity) => {
            return {
                fromQuantity: parseInt(strQuantity),
                unitPrice: item.prices[strQuantity]
            }
        }).sort((a, b) => a.fromQuantity - b.fromQuantity);

        let selectedPrice = 0;
        for (const sortedPrice of sortedPrices) {
            if (item.cart_quantity >= sortedPrice.fromQuantity) {
                selectedPrice = sortedPrice.unitPrice;
            }
        }

        return {
            name: item.name + " | " + item.description,
            quantity: item.cart_quantity,
            unitPrice: selectedPrice
        }
    })

    const handleClearCart = () => {
        AuthService.authHeader().then((token) => {
            axios
                .delete(settings.webservice_url + APIS.cart, { headers: token })
                .then((response) => {
                    if (response.data) {
                        setItems(items.map((item) => { return { ...item, cart_quantity: 0 } }))
                    }
                })
                .catch((error) => {
                    console.error(error);
                });
        });
    }

    return (
        <Main
            style={{
                marginRight: open ? "25rem" : "auto",
            }}
        >
            <div
                style={{
                    display: "flex",
                    justifyContent: "space-between",
                    width: "100%",
                }}
            >
                <div className="col-3">
                    <Title>Articoli</Title>
                </div>
                {/* 
				// @ts-expect-error */}
                <div className="col-9" align="right">
                    <IconButton
                        style={{
                            display: open ? "none" : "",
                            position: "fixed",
                            top: 20,
                            right: 20,
                            backgroundColor: "var(--primary-color)",
                            width: "3.5rem",
                            height: "3.5rem"
                        }}
                        onClick={handleDrawerToggle}
                    >
                        <FontAwesomeIcon icon={faShoppingCart} size="lg" />
                    </IconButton>
                </div>
            </div>
            <div
                style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                }}
            >
                {itemsStatus !== "completed"
                    ? <CircularProgress />
                    : <div
                        style={{
                            display: "flex",
                            flexDirection: "column",
                            gap: "1rem",
                            width: "100%",
                            maxWidth: "1280px",
                        }}
                    >
                        <SearchField
                            label={"Cerca un articolo predefinito"}
                            onSubmit={(newValue) => {
                                setSearchingItemName(newValue);
                            }}
                        />
                        <TableContainer component={Paper}>
                            <Table aria-label="collapsible table">
                                {searchedGroups.map((searchedGroup) =>
                                    <Group
                                        key={searchedGroup.groupId}
                                        isSearching={searchingItemName !== ""}
                                        searchedGroup={searchedGroup}
                                        setItems={setItems}
                                    />
                                )}
                            </Table>
                        </TableContainer>
                    </div>}
            </div>
            <CartDrawer items={selectCartItems()} clearCart={handleClearCart} />
        </Main>
    );
}

export default ItemsPage